// frontend/src/pages/championships/TeamFormInChampionship.jsx

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import championshipService from '../../services/championshipService';
import teamService from '../../services/teamService';
import PixDisplay from '../../components/PixDisplay'; // ✅ 1. IMPORTAR O COMPONENTE PIX
import './TeamFormInChampionship.css';

function TeamFormInChampionship({ onTeamCreated }) {
  const { id: championshipIdFromUrl } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    city: '',
    foundedYear: '',
    badge: null,
  });

  const [championship, setChampionship] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ Adicionado estado de loading

  // ✅ 2. NOVO ESTADO PARA CONTROLAR O MODAL DO PIX
  const [pixData, setPixData] = useState(null);

  useEffect(() => {
    if (championshipIdFromUrl) {
      championshipService.getById(championshipIdFromUrl)
        .then(response => {
          const data = response.data || response;
          setChampionship(data);
        })
        .catch(() => setError('Erro ao carregar campeonato'));
    }
  }, [championshipIdFromUrl]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      badge: e.target.files[0],
    }));
  };

  // ✅ 3. FUNÇÃO `handleSubmit` TOTALMENTE REFEITA
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true);

    if (!championshipIdFromUrl) {
      setError('ID do campeonato não encontrado. Não é possível continuar.');
      setIsSubmitting(false);
      return;
    }

    // Primeiro, cria o time para obter um ID
    const teamData = new FormData();
    teamData.append('name', formData.name);
    teamData.append('city', formData.city);
    teamData.append('foundedYear', formData.foundedYear);
    if (formData.badge) {
      teamData.append('badge', formData.badge);
    }
    // Não associamos o campeonato aqui ainda, apenas criamos o time
    
    try {
      // Passo 1: Criar o time
      const createTeamResponse = await teamService.createTeam(teamData);
      const newTeamId = createTeamResponse._id;

      if (!newTeamId) {
        throw new Error("Falha ao obter o ID do novo time criado.");
      }

      // Passo 2: Tentar inscrever o time no campeonato
      const enrollResponse = await championshipService.addTeams(championshipIdFromUrl, [newTeamId]);

      // Passo 3: Tratar a resposta da inscrição
      if (enrollResponse.data.paymentRequired && enrollResponse.data.pixData) {
        // Precisa pagar
        setSuccess('Time criado! Agora, realize o pagamento para confirmar a inscrição.');
        setPixData(enrollResponse.data.pixData);
      } else {
        // Inscrição gratuita
        setSuccess('Time criado e inscrito com sucesso!');
        setTimeout(() => {
          if (onTeamCreated) onTeamCreated();
          else navigate(`/championships/${championshipIdFromUrl}/teams`);
        }, 2000);
      }
      
      // Limpa o formulário em ambos os casos
      setFormData({ name: '', city: '', foundedYear: '', badge: null });
      document.querySelector('input[type="file"]').value = '';


    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Erro ao criar ou inscrever o time.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="team-form-container">
        {error && <div className="alert error">{error}</div>}
        {success && !pixData && <div className="alert success">{success}</div>}

        <form onSubmit={handleSubmit} className="team-form">
          <h2>Inscrever Novo Time em <br/>"{championship ? championship.name : '...'}"</h2>
          
          <div className="form-group">
            <label>Nome do Time</label>
            <input type="text" name="name" value={formData.name} required onChange={handleChange} disabled={isSubmitting} />
          </div>
          <div className="form-group">
            <label>Cidade</label>
            <input type="text" name="city" value={formData.city} required onChange={handleChange} disabled={isSubmitting} />
          </div>
          <div className="form-group">
            <label>Ano de Fundação (Opcional)</label>
            <input type="number" name="foundedYear" value={formData.foundedYear} onChange={handleChange} disabled={isSubmitting} />
          </div>
          <div className="form-group">
            <label>Logo do Time</label>
            <input type="file" name="badge" accept="image/*" onChange={handleFileChange} required disabled={isSubmitting} />
          </div>
          
          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Processando...' : 'Criar e Inscrever Time'}
          </button>
        </form>
      </div>

      {/* ✅ 4. RENDERIZAÇÃO CONDICIONAL DO MODAL PIX */}
      {pixData && (
        <PixDisplay
          pixData={{
            qrCodeImageUrl: pixData.qrCodeImage,
            qrCodeText: pixData.qrCodeText,
          }}
          onCancel={() => {
            setPixData(null); // Fecha o modal
            setSuccess('');   // Limpa a mensagem de sucesso
            // Redireciona o usuário para a aba de times do campeonato para ver o status
            if (onTeamCreated) onTeamCreated();
            else navigate(`/championships/${championshipIdFromUrl}/teams`);
          }}
        />
      )}
    </>
  );
}

export default TeamFormInChampionship;